import { render, staticRenderFns } from "./AgentQuotas.vue?vue&type=template&id=288c41ea&scoped=true"
import script from "./AgentQuotas.vue?vue&type=script&lang=js"
export * from "./AgentQuotas.vue?vue&type=script&lang=js"
import style0 from "./AgentQuotas.vue?vue&type=style&index=0&id=288c41ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c41ea",
  null
  
)

export default component.exports